<template>
  <div class="header">
    <transition name="fade">
      <div v-if="showPrompt" class="prompt" :class="{'mobile-prompt': isMobile}">
        <div class="prompt-content">
          <p>{{ $t('browser_layer') }}</p>
          <span class="el-icon-close" @click="closePrompt"></span>
        </div>
      </div>
    </transition>
    <div class="header-content">
      <div class="header-content-top">
        <span @click="goHome"><img src="@/assets/images/hsk_mock_logo.png" alt="" /></span>
        <template v-if="!isMobile">
          <!-- <nav-menu></nav-menu> -->
          <user-option></user-option>
        </template>
        <!-- <user-avatar v-else></user-avatar> -->
        <user-function v-if="isMobile"></user-function>
      </div>
    </div>
  </div>
</template>

<script>
import analytics from "@/utils/AnalyticsCenter";
// import NavMenu from "@/components/Layout/components/NavMenu";
import UserOption from "@/components/Layout/components/UserOption";
import UserAvatar from "@/components/Layout/components/UserAvatar";
import UserFunction from "@/components/Layout/components/UserFunction";
import { isChrome } from '@/utils/browser';
export default {
  name: "Header",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPrompt: null,
    }
  },
  components: {
    // NavMenu,
    UserOption,
    UserAvatar,
    UserFunction,
  },
  mounted() {
    // 判断当前浏览器
    this.isShowPrompt()
  },
  methods: {
    goHome() {
      analytics.logEvent("hskweb_toplogo_click");
      this.$router.push('/')
    },
     // 判断是否是ios端的chrome浏览器
    isShowPrompt() {
      // 判断如果session中没有值并且是移动端的非chrome浏览器才展示
      if(!sessionStorage.getItem('hideBrowserLayer') && !isChrome()) this.showPrompt = true
    },
    closePrompt() {
      this.showPrompt = false
      sessionStorage.setItem('hideBrowserLayer', true);
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all .2s;
}
.fade-leave-to {
  opacity: 0;
}
.header {
  width: 100%;
  background: #2C2F46;
  position: sticky;
  top: 0;
  z-index: 30;
  .header-content {
    width: 1200px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    &-top {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .prompt {
    background-color: #faae56;
    min-height: 50px;
    display: flex;
    justify-content: center;
    &-content {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      p {
        font-size: 14px;
        text-align: center;
        flex: 1;
      }
      .el-icon-close {
        cursor: pointer;
      }
    }
    &.mobile-prompt {
      min-height: 40px;
      .prompt-content {
        width: 95vw;
        p {
          font-size: 12px;
          line-height: 20px;
        }
      }
    } 
  }
}
@media screen and (max-width: 768px) {
  .header-content {
    width: 100% !important;
    //height: 100px !important;
    flex-direction: column;
    align-items: flex-start !important;
    justify-content: flex-end !important;
    padding: 0 17px;
  }
}
</style>
